import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, Button } from '../../../shared/components/ui';

const signalIcons = {
  warning: (
    <svg className="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
    </svg>
  ),
  alert: (
    <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  insight: (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
};

const severityStyles = {
  high: 'border-l-4 border-l-red-500 bg-red-50 dark:bg-red-900/30',
  medium: 'border-l-4 border-l-yellow-500 bg-yellow-50 dark:bg-yellow-900/30',
  info: 'border-l-4 border-l-blue-500 bg-blue-50 dark:bg-blue-900/30',
};

function SignalItem({ signal, onAction }) {
  const icon = signalIcons[signal.type] || signalIcons.insight;
  const styles = severityStyles[signal.severity] || severityStyles.info;

  return (
    <div className={`p-4 rounded-lg ${styles}`}>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">{icon}</div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{signal.message}</p>
          {signal.details && (
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-300">{signal.details}</p>
          )}
          {signal.actionable && signal.actionText && (
            <Button
              variant="ghost"
              size="sm"
              className="mt-2 -ml-2 text-blue-600 dark:text-blue-400 hover:text-blue-700"
              onClick={() => onAction && onAction(signal)}
            >
              {signal.actionText} →
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export function PricingSignals({ signals = [], onAction }) {
  if (signals.length === 0) {
    return null;
  }

  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <svg className="w-5 h-5 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Pricing Signals
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {signals.map((signal) => (
            <SignalItem key={signal.id} signal={signal} onAction={onAction} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default PricingSignals;
